import { ENV_VARIABLES } from 'src/common/constants';

export function StagingBanner() {
  if (ENV_VARIABLES.APP_ENVIRONMENT !== 'staging') {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-center gap-2 bg-amber-400 px-4 py-1 text-sm font-semibold text-black">
      <span>STAGING</span>
    </div>
  );
}
